module.exports = __webpack_public_path__ + "static/img/female-bg-id.10f86ae8.png";